import React from "react";
import { motion } from "framer-motion";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import styles from "./page.module.css";

export default function Page({ children }) {
  const showingMyth = useRouteMatch("/explorer/:id");
  const { pathname } = useLocation();

  if (pathname === "/map") return null;
  if (showingMyth) return <>{children}</>;

  // let arrowYPos = 150;
  // if (pathname.indexOf("/maker") > -1) arrowYPos = 200;
  // if (pathname === "/about") arrowYPos = 250;

  return (
    <motion.div
      exit={{ opacity: 0, transition: { duration: 0.2 } }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.1 } }}
    >
      {/* <div className={styles.arrow} style={{ top: arrowYPos }} /> */}
      <div className={styles.page}>
        <Link className={styles.closeButt} to="/">
          X
        </Link>
        <div className={styles.pageContent}>{children}</div>
      </div>
    </motion.div>
  );
}
